















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TipoTramite from "@/models/tipoTramite";
import GenericBTable from "@/core/Generics/GenericBTable";
import Helpers from "../../helpers/helper";
@Component
export default class AplicacionNomina extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;
  @Prop() readonly title!: string;
  @Prop() readonly label!: string;
  @Prop() readonly placeholder!: string;

  descripcion: string = '';
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }

  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }

  created() {
    let props = [];
    props.push(new TipoTramiteComponentProp("title", "string", false, "Título"));
    props.push(new TipoTramiteComponentProp("label", "string", true, "Label"));
    props.push(new TipoTramiteComponentProp("placeholder", "string", false, "Placeholder"));
    this.$emit("render", props);
  }
  @Watch("descripcion")
  set(model: string) {
    if (this.content) {
      let contenido = this.content as any;
      contenido.descripcionReemplazo = model;
      this.$emit("update:content", contenido);
    }
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.tramiteAplicacionNomina) {
        delete contenido.descripcionReemplazo;
      }
      this.$emit("update:content", contenido);
    }
  }
}
